/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Unlimited_InventoryInputs */

const en_pricing_feature_unlimited_inventory = /** @type {(inputs: Pricing_Feature_Unlimited_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited Inventory`)
};

const es_pricing_feature_unlimited_inventory = /** @type {(inputs: Pricing_Feature_Unlimited_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventario Ilimitado`)
};

const fr_pricing_feature_unlimited_inventory = /** @type {(inputs: Pricing_Feature_Unlimited_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventaire illimité`)
};

const de_pricing_feature_unlimited_inventory = /** @type {(inputs: Pricing_Feature_Unlimited_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenztes Inventar`)
};

const id_pricing_feature_unlimited_inventory = /** @type {(inputs: Pricing_Feature_Unlimited_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventaris Tak Terbatas`)
};

/** @type {(inputs: Pricing_Feature_Unlimited_InventoryInputs) => LocalizedString} */
const ja_pricing_feature_unlimited_inventory = en_pricing_feature_unlimited_inventory;

/** @type {(inputs: Pricing_Feature_Unlimited_InventoryInputs) => LocalizedString} */
const zh_pricing_feature_unlimited_inventory = en_pricing_feature_unlimited_inventory;

/** @type {(inputs: Pricing_Feature_Unlimited_InventoryInputs) => LocalizedString} */
const ar_pricing_feature_unlimited_inventory = en_pricing_feature_unlimited_inventory;

/** @type {(inputs: Pricing_Feature_Unlimited_InventoryInputs) => LocalizedString} */
const it_pricing_feature_unlimited_inventory = en_pricing_feature_unlimited_inventory;

/** @type {(inputs: Pricing_Feature_Unlimited_InventoryInputs) => LocalizedString} */
const ru_pricing_feature_unlimited_inventory = en_pricing_feature_unlimited_inventory;

/** @type {(inputs: Pricing_Feature_Unlimited_InventoryInputs) => LocalizedString} */
const pt_pricing_feature_unlimited_inventory = en_pricing_feature_unlimited_inventory;

/** @type {(inputs: Pricing_Feature_Unlimited_InventoryInputs) => LocalizedString} */
const ko_pricing_feature_unlimited_inventory = en_pricing_feature_unlimited_inventory;

/**
* | output |
* | --- |
* | "Unlimited Inventory" |
*
* @param {Pricing_Feature_Unlimited_InventoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_unlimited_inventory = /** @type {((inputs?: Pricing_Feature_Unlimited_InventoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Unlimited_InventoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_unlimited_inventory(inputs)
	if (locale === "es") return es_pricing_feature_unlimited_inventory(inputs)
	if (locale === "fr") return fr_pricing_feature_unlimited_inventory(inputs)
	if (locale === "de") return de_pricing_feature_unlimited_inventory(inputs)
	if (locale === "ja") return ja_pricing_feature_unlimited_inventory(inputs)
	if (locale === "zh") return zh_pricing_feature_unlimited_inventory(inputs)
	if (locale === "ar") return ar_pricing_feature_unlimited_inventory(inputs)
	if (locale === "id") return id_pricing_feature_unlimited_inventory(inputs)
	if (locale === "it") return it_pricing_feature_unlimited_inventory(inputs)
	if (locale === "ru") return ru_pricing_feature_unlimited_inventory(inputs)
	if (locale === "pt") return pt_pricing_feature_unlimited_inventory(inputs)
	return ko_pricing_feature_unlimited_inventory(inputs)
});